function setRem() {
    const baseWidth = 1920;
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
    // if (clientWidth > 1000) {
    let scale = 1;
    // if (clientWidth > 1920) {
    //     scale = 1920 / baseWidth;
    // } else if (clientWidth > 1000) {
    scale = clientWidth / baseWidth;
    // } else {
    //     scale = 0.5;
    // }
    // 设置根元素字体大小
    document.documentElement.style.fontSize = 19.2 * scale + 'px'
    // }
}
setRem();
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', setRem);